/**
 * Routes checkpoint / Notion editor slash → Date to the shared DatePicker calendar.
 * Requires `registerEditorDatePickerHost()` from account/src/notionEditorDatePickerHost.js.
 */
(function initNotionEditorDatePatch() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  if (window.__exiqNotionEditorDatePatchInitialized) {
    return;
  }
  window.__exiqNotionEditorDatePatchInitialized = true;

  const PATCH_FLAG = "__exiqNotionEditorDatePatchApplied";
  const STYLE_ID = "exiq-notion-editor-date-patch-styles";

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
.exiq-editor-date-picker-host {
        pointer-events: auto;
      }
      .exiq-editor-date-picker-host .date-picker-modal-overlay {
        z-index: 100000;
        pointer-events: auto;
      }
      .exiq-editor-date-picker-host .date-picker-modal {
        pointer-events: auto;
      }
    `;
    document.head.appendChild(style);
  }

  function openDatePicker(onSave) {
    if (typeof onSave !== "function") {
      return;
    }

    ensureStyles();

    if (typeof window.__exiqMountEditorDatePicker === "function") {
      window.__exiqMountEditorDatePicker(onSave);
      return;
    }
  }

  function handleDateModalRequest(onSave) {
    window.setTimeout(() => openDatePicker(onSave), 0);
  }

  window.__exiqOpenDatePicker = handleDateModalRequest;

  document.addEventListener(
    "open-date-modal",
    (event) => {
      const detail = event.detail || {};
      if (typeof detail.onSave === "function") {
        event.stopImmediatePropagation();
        handleDateModalRequest(detail.onSave);
      }
    },
    true
  );

  function bindEditorDom(editorDom) {
    if (!editorDom || editorDom[PATCH_FLAG]) {
      return;
    }

    editorDom[PATCH_FLAG] = true;
    editorDom.addEventListener(
      "open-date-modal",
      (event) => {
        const detail = event.detail || {};
        if (typeof detail.onSave === "function") {
          event.stopImmediatePropagation();
          handleDateModalRequest(detail.onSave);
        }
      },
      true
    );
  }

  function scanForEditorRoots(root) {
    if (!root || typeof root.querySelectorAll !== "function") {
      return;
    }

    root.querySelectorAll(".ProseMirror").forEach(bindEditorDom);
  }

  function attachToShadowRoot(shadowRoot) {
    if (!shadowRoot || shadowRoot.__exiqDatePatchShadowBound) {
      return;
    }

    shadowRoot.__exiqDatePatchShadowBound = true;
    scanForEditorRoots(shadowRoot);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.classList.contains("ProseMirror")) {
            bindEditorDom(node);
            return;
          }

          scanForEditorRoots(node);
        });
      });
    }).observe(shadowRoot, {
      childList: true,
      subtree: true,
    });
  }

  function scanCustomElements(root) {
    if (!root || typeof root.querySelectorAll !== "function") {
      return;
    }

    root.querySelectorAll("exiq-notion-editor").forEach((element) => {
      if (element.shadowRoot) {
        attachToShadowRoot(element.shadowRoot);
      }
    });
  }

  function observeEditors() {
    scanForEditorRoots(document);
    scanCustomElements(document);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.tagName === "EXIQ-NOTION-EDITOR" && node.shadowRoot) {
            attachToShadowRoot(node.shadowRoot);
          }

          if (node.classList.contains("ProseMirror")) {
            bindEditorDom(node);
          }

          scanForEditorRoots(node);
          scanCustomElements(node);

          if (node.shadowRoot) {
            attachToShadowRoot(node.shadowRoot);
          }
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeEditors);
  } else {
    observeEditors();
  }
})();
